"use client";

import { api } from "@/lib/api";
import { useClientTranslations } from "@/hooks/useClientTranslations";
import { XError } from "@/utils/error.utils";
import { FeedbackPrompt } from "@/components/desktop/ui";
const FEEDBACK_MAX_LENGTH = 2000;
export function WarehouseFlowFeedback({
  shouldShowMessage
}: {
  shouldShowMessage: boolean;
}) {
  const t = useClientTranslations("desktop.warehouseFlow");
  const fileFeedback = api.freightDashboard.warehouseFlowFeedback.useMutation();
  return <>
            <span aria-hidden="true" className="h-3 w-px bg-ink/10" />
            <FeedbackPrompt maxLength={FEEDBACK_MAX_LENGTH} surface="warehouseFlow" copy={{
      tag: t("alpha.tag"),
      message: shouldShowMessage ? t("alpha.message") : undefined,
      link: t("alpha.link"),
      title: t("alpha.title"),
      placeholder: t("alpha.placeholder"),
      send: t("alpha.send"),
      sent: t("alpha.sent"),
      failed: t("alpha.failed")
    }} onSend={async note => {
      const result = await fileFeedback.mutateAsync({
        note
      });
      if (result.status !== "filed") {
        throw new XError({
          message: "warehouseFlowFeedback: note was not filed",
          data: {
            reason: result.reason
          }
        });
      }
    }} data-sentry-element="FeedbackPrompt" data-sentry-source-file="WarehouseFlowFeedback.tsx" />
        </>;
}